var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-slide",style:({ backgroundImage: ("url(" + (require(("../../assets/images/board-directors/" + (_vm.member.img)))) + ")") }),on:{"mouseenter":_vm.enter,"mouseleave":function($event){return _vm.$emit('leave', _vm.member)},"click":function($event){return _vm.$emit('itemClick', {
      member: _vm.member,
      idx: _vm.idx,
      el: $event.target,
    })}}},[_c('span',[_vm._v(_vm._s(_vm.$t('labels.readmore')))])])}
var staticRenderFns = []

export { render, staticRenderFns }